// this is an autogenerated file from App/Account/Content/Settings/Content/Charges/Content/Content/Charge/ActionsAction/Edit/Content/InsuranceCode/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_Charges_Content_Content_Charge_ActionsAction_Edit_Content_InsuranceCode{
  vaxiom_insurance_codes(
    where: { deleted: { _eq: false } }
    order_by: { code: asc_nulls_last, title: asc_nulls_last }
  ) {
    id
    code
    title
  }
}

`